import { render } from "./WhatWeDoBest.vue?vue&type=template&id=4a5e77b8&scoped=true"
import script from "./WhatWeDoBest.vue?vue&type=script&lang=ts"
export * from "./WhatWeDoBest.vue?vue&type=script&lang=ts"

import "./WhatWeDoBest.vue?vue&type=style&index=0&id=4a5e77b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a5e77b8"

export default script